import { useCallback } from 'react';
import useGetPostCode from '../../gqlCommon/hooks/useGetPostCode';
import { IBasketInitV3Request } from '../../gqlCommon/model/IBasketInitV3Request';
import { financeFormInputVar } from '../../gqlCommon/graphql/cache';
import { IFinanceFormInput } from '../../gqlCommon/model/IFinanceFormInput';
import { JourneyType } from '../../__generated__/globalTypes';
import useVehiclePayload from './useVehiclePayload';
import useCustomizeCarContext from './useCustomizeCarContext';
import useCustomerStorage from '../../common/hooks/useCustomerStorage';

export interface IUseBasketConfigV3Return {
  getBasketInitV3Data: () => IBasketInitV3Request;
}

export const useBasketInitV3 = (journeyType: JourneyType): IUseBasketConfigV3Return => {
  const { selectedCar } = useCustomizeCarContext();
  const selectedFeaturesId = selectedCar?.selectedFeatures.selected;
  const { customerStorage } = useCustomerStorage();
  const dealerId = customerStorage.getCustomerData()?.dealerId || null;
  const postcode = useGetPostCode();

  const savedFinanceFormInput = financeFormInputVar();
  const financeFormInput: IFinanceFormInput | null = savedFinanceFormInput ? { ...savedFinanceFormInput } : null;

  const vehiclePayload = useVehiclePayload();

  const getBasketInitV3Data = useCallback(
    () => ({
      ...vehiclePayload,
      journey: journeyType,
      configurationSourceUrl: window.location.toString(),
      dealerId,
      postcode,
      featureIds: selectedFeaturesId,
      financeFormInput,
    }),
    [dealerId, postcode, selectedFeaturesId, vehiclePayload],
  );

  return { getBasketInitV3Data };
};
